import {css} from '@logistics-frontend/blocks/theme/css'
import {spacing} from '@logistics-frontend/blocks/theme/theme'

export const classes = {
  root: css`
    padding: ${spacing(1)};
  `,
  section: css`
    padding: ${spacing(0.5)};
  `,
  icon: css`
    height: ${spacing(3)};
  `,
}
